import { useEffect, useState } from 'react'
import { useQuery, useMutation, useInfiniteQuery } from 'react-query'
import API, { useGetInfinite } from '.'

const ENDPOINT = '/api/users'
const QUERY_KEY = 'users'

export const useGetUser = (userId, config = {}) =>
  useQuery(
    [QUERY_KEY, 'detail', userId],
    async () => (await API.get(`${ENDPOINT}/${userId}`)).data,
    config
  )

export const useGetUsers = (params) =>
  useQuery(
    [QUERY_KEY, 'list', params],
    async () => (await API.get(`${ENDPOINT}?${new URLSearchParams(params).toString()}`)).data
  )

export const useCreateUser = (config = {}) =>
  useMutation((data) => API.post(ENDPOINT, data), config)

export const useEditUser = (config = {}) => useMutation((data) => API.patch(ENDPOINT, data), config)

export const useGetUsersInfinite = (params = {}, config = {}) =>
  useGetInfinite({ key: QUERY_KEY, endpoint: ENDPOINT, params, config })
